import React, { useState } from "react";
import { FaCheck, FaTelegram } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import { toast } from "react-toastify";

const TelegramTask = ({ user, reward }) => {
  const [islogined, setIsLogined] = useState(false);
  const handleTelegramLogin = async () => {
    const res = await httpReauest("GET", "/user/telegram/islogined");
    if (res.data.data) {
      setIsLogined(true);
      toast.success("You're joined");
    } else {
      toast.error("You're not joined");
    }
  };
  return (
    <div
      className={`${
        (user?.telegram || islogined) && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative border-b py-2 pb-4`}
    >
      <span className="flex items-center gap-2 lg:gap-4">
        <FaTelegram className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2">
            Join Telegram
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}
          </span>
        </span>
      </span>

      {user?.telegram || islogined ? (
        <button
          disabled={user?.telegram || islogined}
          className="start-button    px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          {user?.telegram || islogined ? (
            <>
              <FaCheck color="green" /> Claimed
            </>
          ) : (
            "Start"
          )}
        </button>
      ) : (
        <span className="flex flex-wrap gap-2 justify-end">
          <Link
            disabled={user?.telegram}
            target="_blank"
            to={`https://t.me/filetrustbot?start=${user?._id}`}
            className="start-button    px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            Start
          </Link>
          <button
            onClick={handleTelegramLogin}
            disabled={user?.telegram}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            Check
          </button>
        </span>
      )}
    </div>
  );
};

export default TelegramTask;
